import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import Students from '../components/Students'
import Teachers from '../components/Teachers'
import TeacherEfforts from '../components/TeacherEfforts'
import StudentEfforts from '../components/StudentEfforts'
import Users from '../components/Users'
import Status from '../components/Status'
import Navigation from '../components/layouts/Navigation'
import MyAccount from '../components/MyAccount'
import PasswordRecovery from '../components/PasswordRecovery'
import Classes from '../components/Classes'
import DataManagement from '../components/DataManagement'
import ExportData from '../components/ExportData'
import ImportData from '../components/ImportData'
import Thankyou from '../components/Thankyou'
import ReportingPeriods from '../components/ReportingPeriods'
import StudentClasses from '../components/StudentClasses'
import TeacherClasses from '../components/TeacherClasses'
import Settings from '../components/Settings'
import AcademicData from '../components/AcademicData'
import MyEffortsStudent from '../components/MyEffortsStudent'
import MyEffortsTeacher from '../components/MyEffortsTeacher'
import Courses from '../components/Courses'
import Terms from '../components/Terms'
import StudentDashboard from '../components/StudentDashboard'
import StudentMotionChart from '../components/StudentMotionChart'
import TeacherMotionChart from '../components/TeacherMotionChart'
import MiddleManagers from '../components/MiddleManagers'
import MiddleManagerClasses from '../components/MiddleManagerClasses'
import MiddleManagerTeachers from '../components/MiddleManagerTeachers'
import ClassesMiddleManager from '../components/ClassesMiddleManager'
import UserManagement from '../components/UserManagement'

import { store } from '../store';
import { initialize, getSettings } from '../utils/effort-tracking-api';

Vue.use(Router)

var router = new Router({
  routes: [
      {
        path: '/users/login',
        name: 'Login',
        component: Users,
        beforeEnter: (to, from, next) => {
          initialize().then(x => {
            getSettings().then(settings => {
              localStorage.setItem('background-image', '');
              localStorage.setItem('additional-logo', '');
              localStorage.setItem('welcome-text', '');

              if(settings.length > 0)
              {
                var backgroundImage = settings.filter(ss => ss.key == 'background-image');
                if(backgroundImage.length > 0)
                  localStorage.setItem('background-image', backgroundImage[0].value);

                var additionalLogo = settings.filter(ss => ss.key == 'additional-logo');
                if(additionalLogo.length > 0)
                  localStorage.setItem('additional-logo', additionalLogo[0].value);

                var welcomeText = settings.filter(ss => ss.key == 'welcome-text');
                if(welcomeText.length > 0)
                  localStorage.setItem('welcome-text', welcomeText[0].value);
                  
              } 
              next();
            }).catch(ex => console.log(ex));
          }).catch(ex => console.log(ex));
        }
      },
      {
        path: '/users/passwordrecovery',
        name: 'PasswordRecovery',
        component: PasswordRecovery
      },
      {
        path: '',
        component: Navigation,
        beforeEnter: (to, from, next) => {
          var usertype = store.state.usertype;
          var userdata = store.state.userdata;
          (userdata == null && usertype == '') ? next('/users/login') : next();
        },
        children: [
          {
            path: '/student/:studentId/student-efforts',
            name: 'StudentEfforts',
            component: StudentEfforts,
            meta: { requiresResourceProperty: true }
          },
          {
            path: '/student/:studentId/myefforts',
            name: 'MyEffortsStudent',
            component: MyEffortsStudent,
            meta: { requiresResourceProperty: true }
          },
          {
            path: '/teacher/:teacherId/teacher-efforts',
            name: 'TeacherEfforts',
            component: TeacherEfforts,
            meta: { requiresResourceProperty: true }
          },
          {
            path: '/teacher/:teacherId/students-grades',
            name: 'MyEffortsTeacher',
            component: MyEffortsTeacher
          },
          {
            path: '/home',
            name: 'Home',
            component: Home
          },
          {
            path: '/students',
            name: 'Students',
            component: Students
          },
          {
            path: '/teachers',
            name: 'Teachers',
            component: Teachers
          },
          {
            path: '/status',
            name: 'Status',
            component: Status
          },
          {
            path: '/account',
            name: 'MyAccount',
            component: MyAccount
          },
          {
            path: '/settings',
            name: 'Settings',
            component: Settings
          },
          {
            path: '/academic',
            name: 'AcademicData',
            component: AcademicData
          },
          {
            path: '/classes',
            name: 'Classes',
            component: Classes
          },
          {
            path: '/datamanagement',
            name: 'Data Management',
            component: DataManagement
          },
          {
            path: '/datamanagement/export',
            name: 'Export Data',
            component: ExportData
          },
          {
            path: '/datamanagement/import',
            name: 'Import Data',
            component: ImportData
          },
          {
            path: '/datamanagement/usermanagement',
            name: 'User Management',
            component: UserManagement
          },
          {
            path: '/thankyou',
            name: 'Thankyou',
            component: Thankyou
          },
          {
            path: '/reporting-periods',
            name: 'ReportingPeriods',
            component: ReportingPeriods
          },
          {
            path: '/studentclasses',
            name: 'StudentClasses',
            component: StudentClasses
          },
          {
            path: '/teacherclasses',
            name: 'TeacherClasses',
            component: TeacherClasses
          },
          {
            path: '/courses',
            name: 'Courses',
            component: Courses
          },
          {
            path: '/terms',
            name: 'Terms',
            component: Terms
          },
          {
            path: '/student/:studentId/dashboard',
            name: 'StudentDashboard',
            component: StudentDashboard,
            meta: { requiresResourceProperty: true }
          },
          {
            path: '/student/:studentId/motionchart',
            name: 'StudentMotionChart',
            component: StudentMotionChart,
            meta: { requiresResourceProperty: true }
          },
          {
            path: '/motionchart',
            name: 'TeacherMotionChart',
            component: TeacherMotionChart,
          },
          {
            path: '/middle-managers',
            name: 'MiddleManagers',
            component: MiddleManagers
          },
          {
            path: '/middle-manager-classes',
            name: 'MiddleManagerClasses',
            component: MiddleManagerClasses
          },
          {
            path: '/middle-manager-teachers',
            name: 'MiddleManagerTeachers',
            component: MiddleManagerTeachers

          },
          {
            path: '/classes-middle-manager',
            name: 'ClassesMiddleManager',
            component: ClassesMiddleManager
          }
      ]
    },
    { path: '*', redirect: '/home' }
  ]
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js